import { Component, OnInit } from '@angular/core';
import { IStrapiDocument, Profile } from 'src/app/interfaces/strapi';

import { PageComponent } from 'src/app/shared/components/page/page.component';
import { Meta, Title } from '@angular/platform-browser';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { UniService } from '../../../services/uni.service';
import { UserService } from '../../../services/user.service';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { DeleteUserConfirmationComponent } from '../../../shared/components/delete-user-confirmation/delete-user-confirmation.component';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    imports: [
        BreadcrumbsComponent,
        NgIf,
        ModalComponent,
        DeleteUserConfirmationComponent,
        RouterLink,
    ],
})
export class ProfileComponent extends PageComponent implements OnInit {
  public override pageData: Profile = <Profile>{};

  public showDeleteAccountModal = false;

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,
    public override readonly strapi: StrapiService,
    public readonly uniService: UniService,
    public readonly auth: AuthService,
    private readonly userService: UserService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.strapi.getProfile().subscribe({
      next: (data: IStrapiDocument<Profile>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
      },
      error: () => {
        this.pageRetrievalError = true;
      },
    });
  }

  protected override parsePageData(page: Profile): void {
    super.parsePageData(page);
    this.pageData = page;
  }

  toggleAccoutDeletionModal() {
    this.showDeleteAccountModal = !this.showDeleteAccountModal;
  }

  deleteAccount() {
    this.userService.deleteUser(this.auth.currentUser!).subscribe(() => {
      this.auth.logout();
    });
  }
}
